import { render, staticRenderFns } from "./classroom-pagination-dropdown.vue?vue&type=template&id=0fe9203b&"
import script from "./classroom-pagination-dropdown.vue?vue&type=script&lang=js&"
export * from "./classroom-pagination-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports